import React from 'react';
import {
  Icon,
  Menu,
  MenuItem,
  MenuDivider,
  Spacer,
  Tag,
} from '@pypestream/design-system';
import {
  AGENT_TEMPLATES_CATEGORY,
  MICROAGENT_CATEGORIES,
  UNCATEGORIZED_CATEGORY,
  type MicroagentCategory,
} from './category-map';

export const MicroagentCategories: React.FC<{
  counts: Record<string, number>;
  onSelect: (categoryId: string) => void;
  /** Project Bobcat: the prototype's `.library-row` list. */
  polished?: boolean;
}> = ({ counts, onSelect, polished }) => {
  // Agent templates first, and only when the flag has put any in the list.
  const listed: MicroagentCategory[] = counts[AGENT_TEMPLATES_CATEGORY.id]
    ? [AGENT_TEMPLATES_CATEGORY, ...MICROAGENT_CATEGORIES]
    : MICROAGENT_CATEGORIES;
  // Names the category map does not know land in "Uncategorized"; listed in
  // both menus, or those microagents have no way in (PSTUDIO-4586).
  const categories: MicroagentCategory[] = counts[UNCATEGORIZED_CATEGORY.id]
    ? [...listed, UNCATEGORIZED_CATEGORY]
    : listed;
  if (polished) {
    return (
      <div className="c-lib-list">
        {categories.map((category) => (
          <button
            key={category.id}
            type="button"
            className="c-lib-row"
            data-testid="bobcat-library-category"
            onClick={() => onSelect(category.id)}
          >
            <span className="c-lib-row__icon">
              <Icon size="small" name={category.icon} />
            </span>
            <span className="c-lib-row__name">{category.name}</span>
            <span className="c-lib-row__count">{counts[category.id] ?? 0}</span>
          </button>
        ))}
      </div>
    );
  }

  return (
    <>
      <Spacer size="xsmall" />
      <Menu>
        {categories.map((category, i) => (
          <React.Fragment key={category.id}>
            <MenuItem onClick={() => onSelect(category.id)}>
              <Icon slot="prefix" size="small" name={category.icon} />
              {category.name}
              {counts[category.id] ? (
                <Tag minimal size="small" slot="suffix">
                  {counts[category.id]}
                </Tag>
              ) : null}
              <Icon slot="suffix" size="small" name="chevron-right" />
            </MenuItem>
            {i + 1 !== categories.length && (
              <MenuDivider key={`${category.id}-divider`} />
            )}
          </React.Fragment>
        ))}
      </Menu>
    </>
  );
};
